import axios from 'axios';
import { API_URL } from 'utils';
import { object, string } from 'yup';

/**
 * RegExp for
 * Must Contain
 * 8 Characters,
 * One Uppercase,
 * One Lowercase,
 * One Number and One Special Case Character
 * .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})
 */
export const loginSchema = object({
  email: string('Email is required').required().email(),
  password: string('Please Enter your password').min(6).required(),
}).required();

/**
 * @typedef {import('yup').InferType<typeof loginSchema>} LoginData
 *
 * @typedef {object} TLogin
 * @property {string} _id
 * @property {string} username
 * @property {string} accessToken
 * @property {number[] | null} roles
 */

/**
 * @param {LoginData} data
 * @return {Promise<TLogin>}
 */
export default async function login(data) {
  try {
    const response = await axios.post(
      `${API_URL}/auth/login`,
      {
        username: data.email,
        password: data.password,
      },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}
